module.exports = __webpack_public_path__ + "img/w3_button_check_light.8c72a426.png";